"use client";

import { PropsWithChildren, useEffect } from "react";
import { usePathname } from "next/navigation";
import { trackEventApi } from "./hooks/track-event-api";
import { ClientTrackingEvent } from "../helpers/event-tracking-helpers";

export const NewsReadEventTracking = (props: PropsWithChildren) => {
  const pathname = usePathname();
  useEffect(() => {
    trackEventApi(
      {
        event: ClientTrackingEvent.NEWS_READ,
      },
      pathname
    );
  }, []);

  return <div></div>;
};
